import './UserDetails.css'
import React, { Component } from 'react';
import * as PropTypes from "prop-types";
import {Tab, Table, Tabs} from "react-bootstrap";
import moment from "moment";
import Spiner from '../../helpers/Spiner/Spiner';
import { getUserCountQuestion, getUserTransaction, getUserLastLogin } from './actions';

class UserDetails extends Component {
	constructor(props) {
		super(props)
		this.state = {
			transactions: [],
			last_login: [],
			loaded_transactions: false,
			loaded_counts: false,
			counts: {
					q_count_total: 0,
					q_count_enabled: 0,
					q_count_disabled: 0,
					q_count_temp: 0,
			}
		}
	}

	async componentDidMount(){
    const {user} = this.props;
    const counts = await getUserCountQuestion({user_id: user.id});
    const transactions = await getUserTransaction({user_id: user.id});
    const last_login = await getUserLastLogin({user_id: user.id});
    this.setState({
      counts,
      last_login,
      transactions,
      loaded_counts: true,
      loaded_transactions: true,
    });
  }

	render() {
		const {user} = this.props;
		const {q_count_total} = user;
		const { counts, loaded_counts, transactions, loaded_transactions, last_login}  = this.state;

		return (
			<Tabs defaultActiveKey="loginHistory" id="uncontrolled-tab" variant={'pills'}>
				<Tab eventKey="loginHistory" title="Login History">
					{
						last_login.length === 0 ?
							<p className={'empty-message'}>Login history is empty</p> :
							<Table striped bordered hover>
								<thead>
								<tr>
										<th>#</th>
										<th>Date</th>
								</tr>
								</thead>
								<tbody>
								{
										last_login.map(({login_time}, i) => (
												<tr key={i}>
														<td>{i + 1}</td>
														<td>{moment.unix(login_time).format('MMMM Do YYYY, h:mm:ss a')}</td>
												</tr>
										))
								}
								</tbody>
							</Table>
					}
				</Tab>
				{/* <Tab eventKey="questions" title="Questions">
						{!loaded_counts && <div style={{minHeight: '255px'}}><Spiner /></div>}
						{loaded_counts && <Table striped bordered hover>
								<thead>
								<tr>
										<th>Type</th>
										<th>Count</th>
								</tr>
								</thead>
								<tbody>
										<tr>
												<td>Disabled</td>
												<td>{counts.q_count_disabled}</td>
										</tr>
										<tr>
												<td>Enabled</td>
												<td>{counts.q_count_enabled}</td>
										</tr>
										<tr>
												<td>Temporary</td>
												<td>{counts.q_count_temp}</td>
										</tr>
										<tr>
												<td>Total</td>
												<td>{counts.q_count_total}</td>
										</tr>
								</tbody>
						</Table>}
				</Tab> */}
				<Tab eventKey="transactions" title="Transactions">
					{!loaded_transactions && <div style={{minHeight: '255px'}}><Spiner /></div>}
					{loaded_transactions && <Table striped bordered hover>
						<thead>
						<tr>
							<th>Date</th>
							<th>Amount</th>
							<th>Months</th>
							<th>Discount</th>
						</tr>
						</thead>
						<tbody>
							{transactions.map((tr, index) => <tr>
								<td>{moment.unix(tr.created_at).format('MMMM Do YYYY')}</td>
								<td>${tr.amount} USD</td>
								<td>{tr.months}</td>
								<td>{tr.procent}%</td>
							</tr>)}
						</tbody>
					</Table>}
				</Tab>
			</Tabs>
		)
	}
}

UserDetails.propTypes = {
    user: PropTypes.object
}
export default UserDetails



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Users/UserDetails.js